import React, { useEffect, useState } from 'react'
import ReactQuill from "react-quill";
import { useDispatch, useSelector } from 'react-redux';
import { clearErrors, loadSettingsAction, saveSystemSettingsAction } from '../../redux/actions/userActions';
import { toast } from 'react-toastify';
import api from '../../api';



const DefaultConfigurations = () => {

    const dispatch = useDispatch();


    const { loading, error, message } = useSelector(state => state.inviteUser)
    const { settings } = useSelector(state => state.loadSettings)

    const [pm_commission_rate, setPm_commission_rate] = useState("")
    const [portal_commission_rate, setPortal_commission_rate] = useState("")
    const [instruction_description, setInstruction_description] = useState("")
    const [refund_description, setRefund_description] = useState("")
    const [commission_description, setCommission_description] = useState("")
    const [announcement, setAnnouncement] = useState("")


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!pm_commission_rate || !portal_commission_rate) {
            toast.error("Please fill in all required fields.")
            return;
        }

        const data = {
            pm_commission_rate,
            portal_commission_rate,
            instruction_description,
            refund_description,
            commission_description,
            announcement
        }
        dispatch(saveSystemSettingsAction(data))

        if (announcement) {
            try {
                await api.post(`/api/v1/create-announcement`, { content: announcement });
                toast.success("Announcement broadcasted successfully!");
            } catch (error) {
                toast.error(error.response?.data?.message || "Failed to broadcast announcement");
            }
        }
    }


    useEffect(() => {
        if (message) {
            toast.success(message)
            dispatch({ type: "SAVE_SETTINGS_RESET" })
        }
        if (error) {
            toast.error(error)
            dispatch(clearErrors())
        }
    }, [message, error, dispatch])



    useEffect(() => {
        if (settings) {
            setPm_commission_rate(settings.pm_commission_rate || "")
            setPortal_commission_rate(settings.portal_commission_rate || "")
            setInstruction_description(settings.instruction_description || "")
            setRefund_description(settings.refund_description || "")
            setCommission_description(settings.commission_description || "")
            setAnnouncement(settings.announcement || "")
        }
    }, [settings])


    useEffect(() => {
        dispatch(loadSettingsAction())
    }, [dispatch])

    return (
        <form onSubmit={handleSubmit} className="mt-[2vmax]" >
            <div className='grid grid-cols-1 lg:grid-cols-2 gap-[2vmax] gap-y-[3vmax]' >

                {/* Left Column: Commission Rates */}
                <div className="flex flex-col gap-[2vmax]">
                    <div className='flex flex-col'>
                        <label className='text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider'>
                            PM Commission (PKR) <span className='text-red-500'>*</span>
                        </label>
                        <input
                            type="number"
                            value={pm_commission_rate}
                            onChange={(e) => setPm_commission_rate(e.target.value)}
                            className='w-full px-[1vmax] py-[0.7vmax] bg-gray-50 border border-gray-100 rounded-lg outline-none focus:border-indigo-300 transition-colors text-[0.9vmax] mt-[0.5vmax] font-medium text-gray-700'
                        />
                    </div>
                    <div className='flex flex-col'>
                        <label className='text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider'>
                            Zonify Pro Commission (PKR) <span className='text-red-500'>*</span>
                        </label>
                        <input
                            type="number"
                            value={portal_commission_rate}
                            onChange={(e) => setPortal_commission_rate(e.target.value)}
                            className='w-full px-[1vmax] py-[0.7vmax] bg-gray-50 border border-gray-100 rounded-lg outline-none focus:border-indigo-300 transition-colors text-[0.9vmax] mt-[0.5vmax] font-medium text-gray-700'
                        />
                    </div>
                    
                    {/* Announcement */}
                    <div className='flex flex-col'>
                        <label className='text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider'>Announcement</label>
                        <div className="mt-[0.5vmax] border border-gray-100 rounded-lg overflow-hidden h-[200px] flex flex-col bg-white">
                            <ReactQuill
                                theme="snow"
                                value={announcement}
                                onChange={(value) => setAnnouncement(value)}
                                className="flex-1 flex flex-col"
                                modules={{
                                    toolbar: [
                                        [{ 'header': [1, 2, 3, false] }],
                                        ['bold', 'italic', 'underline', 'strike'],
                                        [{ 'color': [] }, { 'background': [] }],
                                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                        ['clean']
                                    ]
                                }}
                                formats={[
                                    'header',
                                    'bold', 'italic', 'underline', 'strike',
                                    'color', 'background',
                                    'list', 'bullet'
                                ]}
                            />
                        </div>
                    </div>
                </div>

                {/* Right Column: Default Instructions */}
                <div className='flex flex-col'>
                    <label className='text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider'>Default Instructions</label>
                    <div className="mt-[0.5vmax] border border-gray-100 rounded-lg overflow-hidden h-[200px] flex flex-col bg-white">
                        <ReactQuill
                            theme="snow"
                            value={instruction_description}
                            onChange={(value) => setInstruction_description(value)}
                            className="flex-1 flex flex-col"
                            modules={{
                                toolbar: [
                                    [{ 'header': [1, 2, 3, false] }],
                                    ['bold', 'italic', 'underline', 'strike'],
                                    [{ 'color': [] }, { 'background': [] }],
                                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                    ['clean']
                                ]
                            }}
                            formats={[
                                'header',
                                'bold', 'italic', 'underline', 'strike',
                                'color', 'background',
                                'list', 'bullet'
                            ]}
                        />
                    </div>
                </div>

                {/* Bottom Row Left: Default Refund Instructions */}
                <div className='flex flex-col'>
                    <label className='text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider'>Default Refund Instructions</label>
                    <div className="mt-[0.5vmax] border border-gray-100 rounded-lg overflow-hidden h-[200px] flex flex-col bg-white">
                        <ReactQuill
                            theme="snow"
                            value={refund_description}
                            onChange={(value) => setRefund_description(value)}
                            className="flex-1 flex flex-col"
                            modules={{
                                toolbar: [
                                    [{ 'header': [1, 2, 3, false] }],
                                    ['bold', 'italic', 'underline', 'strike'],
                                    [{ 'color': [] }, { 'background': [] }],
                                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                    ['clean']
                                ]
                            }}
                            formats={[
                                'header',
                                'bold', 'italic', 'underline', 'strike',
                                'color', 'background',
                                'list', 'bullet'
                            ]}
                        />
                    </div>
                </div>

                {/* Bottom Row Right: Default Commission Instructions */}
                <div className='flex flex-col'>
                    <label className='text-[0.85vmax] font-medium text-gray-500 uppercase tracking-wider'>Default Commission Instructions</label>
                    <div className="mt-[0.5vmax] border border-gray-100 rounded-lg overflow-hidden h-[200px] flex flex-col bg-white">
                        <ReactQuill
                            theme="snow"
                            value={commission_description}
                            onChange={(value) => setCommission_description(value)}
                            className="flex-1 flex flex-col"
                            modules={{
                                toolbar: [
                                    [{ 'header': [1, 2, 3, false] }],
                                    ['bold', 'italic', 'underline', 'strike'],
                                    [{ 'color': [] }, { 'background': [] }],
                                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                    ['clean']
                                ]
                            }}
                            formats={[
                                'header',
                                'bold', 'italic', 'underline', 'strike',
                                'color', 'background',
                                'list', 'bullet'
                            ]}
                        />
                    </div>
                </div>
            </div>

            {/* Submit Button */}
            <div className='flex justify-center mt-[3vmax]' >
                <button 
                    type='submit' 
                    className='bg-indigo-600 hover:bg-indigo-700 text-white px-[2.5vmax] py-[0.7vmax] rounded-lg text-[0.9vmax] font-bold transition-colors shadow-sm disabled:opacity-50 disabled:cursor-not-allowed'
                    disabled={loading}
                >
                    {loading ? "Saving..." : "Save Settings"}
                </button>
            </div>
        </form>
    )
}

export default DefaultConfigurations